import React, { useState, useEffect } from 'react';
import Bars from '../Bars';
import { NavLink } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';

function CurrentAltitude() {
  const [altitude, setAltitude] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!navigator.geolocation) {
      setError("Twoja przeglądarka nie wspiera geolokalizacji.");
      return;
    }

    const success = (position) => {
      setAltitude(position.coords.altitude);
    };

    const fail = (err) => {
      setError("Nie udało się pobrać wysokości.");
      console.error(err);
    };

    navigator.geolocation.getCurrentPosition(success, fail);
  }, []);

  return (
    <>

      <NavLink to="/info" className="backLink userSelectNone">
        <FiArrowLeft className="backIcon" />
        <span>Powrót</span>
      </NavLink>

      <div style={{ padding: '10px', border: '1px solid #ccc', borderRadius: '8px' }}>

        <h3>Twoja aktualna wysokość:</h3>
        
        {altitude !== null ? (
          <p>{altitude.toFixed(0)} m n.p.m.</p>
        ) : error ? (
          <p>{error}</p>
        ) : (
          <p>Ładowanie...</p>
        )}

      </div>

      <Bars />

    </>
  );
}

export default CurrentAltitude;
